import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { ErrorDisplayService } from '../services/error-display.abstract-service';
import { isProbablyFirewallBlock } from '../utils/firewall-block.util';

/**
 * Surfaces the generic security message when a request is blocked upstream
 * (likely Cloud Armor) instead of reaching the BE. Living in the HTTP layer,
 * it also covers callers that swallow the error in a local `catchError` before
 * it reaches the global ErrorHandler. It always rethrows so caller state (e.g.
 * loading flags) is unaffected.
 */
@Injectable()
export class FirewallBlockInterceptor implements HttpInterceptor {
    private errorDisplayService = inject(ErrorDisplayService);

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler,
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: unknown) => {
                if (
                    error instanceof HttpErrorResponse &&
                    error.url?.includes('/api/') &&
                    isProbablyFirewallBlock(error)
                ) {
                    this.errorDisplayService.error(
                        'SHARED.ERROR.HTTP_STATUS.OWASP',
                    );
                }
                return throwError(() => error);
            }),
        );
    }
}

export const firewallBlockInterceptor: HttpInterceptorFn = (req, next) => {
    return inject(FirewallBlockInterceptor).intercept(req, { handle: next });
};
